import { useState } from "react"
import { useDispatch } from "react-redux"

import "./index.scss"

import { ConfigContainer } from "components"
import { Title, Container, Text } from "components/Form"
import { assets } from "state_management"
import useT from "utils/hooks/useT"

// Configuration for instruments.
export default function AssetConfig({ asset, onClose }) {
  const dispatch = useDispatch()
  const { t } = useT("common")
  const [name, setName] = useState(asset ? asset.name : "")

  return (
    <ConfigContainer
      title={asset ? t("editInstrument") : t("addInstrument")}
      submitHandler={() => {
        setName(name.trim())
        const res = { name: name.trim() }
        if (asset) {
          dispatch(assets.edit(asset.id, res)).then(onClose)
        } else {
          dispatch(assets.create(res)).then(onClose)
        }
      }}
      cancelHandler={onClose}
    >
      <Container>
        <Title>{t("instrumentName")}</Title>
        <Text value={name} required onChange={setName} />
      </Container>
    </ConfigContainer>
  )
}
